'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var reactContext = require('@chakra-ui/react-context');
require('../../icons/AccountAdd.js');
require('../../icons/AccountCheck.js');
require('../../icons/AccountRemove.js');
require('../../icons/AccountStar.js');
require('../../icons/Account.js');
require('../../icons/ArrowCollapse.js');
require('../../icons/ArrowDownDrop.js');
require('../../icons/ArrowExpand.js');
require('../../icons/ArrowLeftDrop.js');
require('../../icons/ArrowLeft.js');
require('../../icons/ArrowRightDrop.js');
require('../../icons/Bell.js');
require('../../icons/BullhornOutline.js');
require('../../icons/BurgerMenu.js');
require('../../icons/CalendarDetailed.js');
require('../../icons/CalendarOutline.js');
require('../../icons/CashOff.js');
require('../../icons/Cash.js');
require('../../icons/CautionDecagram.js');
require('../../icons/CautionOutline.js');
require('../../icons/CheckCircled.js');
require('../../icons/CheckDecagram.js');
require('../../icons/CheckOutlinedCircled.js');
var Check = require('../../icons/Check.js');
require('../../icons/ChevronDown.js');
require('../../icons/ChevronLeft.js');
require('../../icons/ChevronRight.js');
require('../../icons/ChevronUp.js');
require('../../icons/CircleOutline.js');
require('../../icons/ClipboardTextOutline.js');
require('../../icons/Clock.js');
var CloseCircleFilled = require('../../icons/CloseCircleFilled.js');
require('../../icons/Close.js');
require('../../icons/CompareArrows.js');
require('../../icons/Corner.js');
require('../../icons/Critical.js');
require('../../icons/Delete.js');
require('../../icons/DocumentEditCircled.js');
require('../../icons/DocumentEditOutline.js');
require('../../icons/DotsVertical.js');
require('../../icons/DownloadFilled.js');
require('../../icons/Draft.js');
require('../../icons/Encryption.js');
require('../../icons/EuroOff.js');
require('../../icons/Euro.js');
require('../../icons/EyeOff.js');
require('../../icons/Eye.js');
require('../../icons/FlagCheckered.js');
require('../../icons/FwSet0Constructionyear1.js');
require('../../icons/FwSet0Constructionyear2.js');
require('../../icons/FwSet0Constructionyear3.js');
require('../../icons/FwSet0Constructionyear4.js');
require('../../icons/FwSet0Corner.js');
require('../../icons/FwSet0Corneretc.js');
require('../../icons/FwSet0CultivableLimited.js');
require('../../icons/FwSet0CultivableNo.js');
require('../../icons/FwSet0CultivableUnsure.js');
require('../../icons/FwSet0Cultivable.js');
require('../../icons/FwSet0ElevatorNo.js');
require('../../icons/FwSet0Elevator.js');
require('../../icons/FwSet0Flat.js');
require('../../icons/FwSet0Garage.js');
require('../../icons/FwSet0House.js');
require('../../icons/FwSet0IndustryDontKnow.js');
require('../../icons/FwSet0IndustryIndustry.js');
require('../../icons/FwSet0IndustryLiveBusiness.js');
require('../../icons/FwSet0IndustryOffice.js');
require('../../icons/FwSet0Industry.js');
require('../../icons/FwSet0KitchenNew.js');
require('../../icons/FwSet0KitchenNo.js');
require('../../icons/FwSet0KitchenOld.js');
require('../../icons/FwSet0LandDevelopmentFull.js');
require('../../icons/FwSet0LandDevelopmentInPart.js');
require('../../icons/FwSet0LandDevelopmentNo.js');
require('../../icons/FwSet0Level1.js');
require('../../icons/FwSet0Level2.js');
require('../../icons/FwSet0Level3.js');
require('../../icons/FwSet0Levelplus.js');
require('../../icons/FwSet0LivingspaceUnknown.js');
require('../../icons/FwSet0Livingspace100.js');
require('../../icons/FwSet0Livingspace200.js');
require('../../icons/FwSet0Livingspace200Plus.js');
require('../../icons/FwSet0ParkingNo.js');
require('../../icons/FwSet0Parking.js');
require('../../icons/FwSet0PlotUnknown.js');
require('../../icons/FwSet0Plot.js');
require('../../icons/FwSet0Plot1000.js');
require('../../icons/FwSet0Plot1000Plus.js');
require('../../icons/FwSet0Plot300.js');
require('../../icons/FwSet0Rooms.js');
require('../../icons/FwSet0SemiDetached.js');
require('../../icons/FwSet0TownhouseCorner.js');
require('../../icons/FwSet0TownhouseMiddle.js');
require('../../icons/GiftCircled.js');
require('../../icons/Hausgold.js');
require('../../icons/HelpOutline.js');
require('../../icons/Help.js');
require('../../icons/HomeOutline.js');
require('../../icons/HouseCircled.js');
require('../../icons/HousePerson.js');
require('../../icons/House.js');
require('../../icons/Industry.js');
require('../../icons/InfoFilled.js');
var InfoOutline = require('../../icons/InfoOutline.js');
require('../../icons/LabelPercent.js');
require('../../icons/Level2.js');
require('../../icons/LightbulbOn.js');
require('../../icons/LockCircledOutline.js');
require('../../icons/Lock.js');
require('../../icons/Magnifier.js');
require('../../icons/Mail.js');
require('../../icons/Map.js');
require('../../icons/MissingOutline.js');
require('../../icons/OkCircled.js');
require('../../icons/OpenBookOutline.js');
require('../../icons/PageFirst.js');
require('../../icons/PageLast.js');
require('../../icons/Pause.js');
require('../../icons/Pen.js');
require('../../icons/Percent.js');
require('../../icons/PhoneCircled.js');
require('../../icons/Phone.js');
require('../../icons/PiggyBankCircled.js');
require('../../icons/PiggyBank.js');
require('../../icons/Plus.js');
require('../../icons/PremiumStars.js');
require('../../icons/Printer.js');
require('../../icons/RealtyCommercial.js');
require('../../icons/RealtyFlat.js');
require('../../icons/RealtyHouse.js');
require('../../icons/RealtySite.js');
require('../../icons/Rocket.js');
require('../../icons/Rooms.js');
require('../../icons/SpeechBubble.js');
require('../../icons/SpeechBubbles.js');
require('../../icons/Speedometer.js');
require('../../icons/Star.js');
require('../../icons/StatusDontknow.js');
require('../../icons/SwapHorizontalBold.js');
require('../../icons/ThumbDownOutline.js');
require('../../icons/ThumbUpOutline.js');
require('../../icons/TruckFastOutline.js');
require('../../icons/UnorderedList.js');
require('../../icons/User.js');
var Spinner = require('../Spinner/Spinner.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _createContext = reactContext.createContext({
    name: 'AlertContext',
    hookName: 'useAlertContext',
    providerName: '<Alert />'
  }),
  _createContext2 = _slicedToArray__default["default"](_createContext, 2),
  AlertProvider = _createContext2[0],
  useAlertContext = _createContext2[1];
var _createContext3 = reactContext.createContext({
    name: "AlertStylesContext",
    hookName: "useAlertStyles",
    providerName: '<Alert />'
  }),
  _createContext4 = _slicedToArray__default["default"](_createContext3, 2),
  AlertStylesProvider = _createContext4[0],
  useAlertStyles = _createContext4[1];
var STATUSES = {
  info: {
    icon: InfoOutline.InfoOutline,
    colorScheme: 'blue'
  },
  warning: {
    icon: null,
    colorScheme: 'yellow'
  },
  success: {
    icon: Check.Check,
    colorScheme: 'green'
  },
  error: {
    icon: CloseCircleFilled.CloseCircleFilled,
    colorScheme: 'red'
  },
  loading: {
    icon: Spinner.Spinner,
    colorScheme: 'blue'
  }
};
function getStatusColorScheme(status) {
  return STATUSES[status].colorScheme;
}
function getStatusIcon(status) {
  return STATUSES[status].icon;
}
var AlertStatus = Object.keys(STATUSES);
exports.AlertProvider = AlertProvider;
exports.AlertStatus = AlertStatus;
exports.AlertStylesProvider = AlertStylesProvider;
exports.getStatusColorScheme = getStatusColorScheme;
exports.getStatusIcon = getStatusIcon;
exports.useAlertContext = useAlertContext;
exports.useAlertStyles = useAlertStyles;